function initSwiper() {
  const swiperEls = document.querySelectorAll('.swiper[data-swiper]');
  swiperEls.forEach((swiperEl) => {
    if (
      !swiperEl.classList.contains('connected-products')
      || window.innerWidth < 990
    ) return;

    const options = JSON.parse(swiperEl.dataset.swiper || {});
    const swiper = new Swiper(swiperEl, { ...options });
    
    const swiperInitEvent = new CustomEvent('swiper-initiated');
    document.dispatchEvent(swiperInitEvent);
  });
}

if (!Swiper) return;

window.addEventListener('load', initSwiper);
['loaded-more-items', 'loaded-recommendations'].forEach((event) => {
  document.addEventListener(event, () => {
    initSwiper();
  });
});
export default initSwiper;
